document.addEventListener("DOMContentLoaded", function() {  

  document.querySelectorAll('.product-variant').forEach( (e) => {
    e.addEventListener('click', function(){
      
      const variantsMedia = document.querySelectorAll('.product-gallery__media, .product-gallery__thumbnail');
      let $metaimage_found = false, $metaimage_vid, $media_first_main = false, $media_first_thumb = false;
      variantsMedia.forEach((selectors, index) => {
        
        var selVariantId = e.dataset.id;
        var selPromoBadge = e.dataset.logo;
        /*---- Start Main Gallery ----*/
        if(document.querySelector('.product-gallery__media-list .product-gallery__media')){
          document.querySelectorAll('.product-gallery__media-list .product-gallery__media').forEach(function($media, idx){
            if($media.getAttribute('data-variant')){
              // console.log("selVariantId",selVariantId);
              // console.log("selPromoBadge",selPromoBadge);
                // console.log("$media.getAttribute('data-variant')", $media.getAttribute('data-variant'));
              if(parseInt(selVariantId) === parseInt($media.getAttribute('data-variant'))){
                $metaimage_found = true;
                $metaimage_vid = selVariantId;
              }
            }
            var meidaAll = document.querySelectorAll('.product-gallery__thumbnail[data-variant="'+selVariantId+'"]')[0];
            
          });
        }
        /*---- End Main Gallery ----*/

        /*---- Start Thumb ----*/
        if(document.querySelector('.product-gallery__thumbnail')){
          document.querySelectorAll('.product-gallery__thumbnail').forEach(function($media, idx){

            if($media.getAttribute('data-variant')){
              if(parseInt(selVariantId) === parseInt($media.getAttribute('data-variant'))){
                // console.log("selVariantId",selVariantId);
                // console.log("$media.getAttribute('data-variant')", $media.getAttribute('data-variant'));
                $metaimage_found = true;
                $metaimage_vid = selVariantId;
              }
            }
            if(idx === (document.querySelectorAll('.product-gallery__thumbnail').length - 1)){
              if($metaimage_found){
                document.querySelectorAll('.product-gallery__thumbnail').forEach(function($media_show, idx){
                  if(parseInt($media_show.getAttribute('data-variant')) === parseInt($metaimage_vid)){     
                    // console.log("true000---")
                    // console.log("parseInt($metaimage_vid)",parseInt($metaimage_vid));
                    // console.log("$media.getAttribute('data-variant')-----2", $media_show.getAttribute('data-variant'));
                    $media_show.removeAttribute('hidden');
                    if(!$media_first_thumb){
                      $media_first_thumb = true;
                      $media_show.click();
                      $media_show.dispatchEvent(new Event('click'));
                      $media_show.querySelector('a').classList.add('mz-thumb-selected');
                      var meidaAll =  document.querySelectorAll('.product-gallery__thumbnail[data-variant="'+selVariantId+'"]')[0];
                      meidaAll.click();
                    }
                  } else{
                    $media_show.setAttribute('hidden', 'hidden');
                    $media_show.querySelector('a').classList.remove('mz-thumb-selected');
                  }
                  if($media_show.getAttribute('data-variant') == 'default'){
                    $media_show.removeAttribute('hidden');
                    if(!$media_first_thumb){
                      $media_first_thumb = true;
                      $media_show.click();
                    }
                  }
                });
              }
              else {
               // var meidaDefault =  document.querySelectorAll('.product-gallery__thumbnail[data-variant="default"]')[0];
                // meidaDefault.click();
                // console.log("true---3333-");
              }
            }
        });
      }
      /*---- End Thumb ----*/

        // ----- Promo Badge ------
        
      });
      // var container = e.closest('.product-template-inner-wrap-container');
      // if(container){
      //   var logoContainer = container.querySelector('.product-gallery-container .product-gallery .wrapper-promo-badge');
      //   var variantlogo =  e.dataset.logo;
      //   if (logoContainer) {
      //     if (variantlogo) {
      //         logoContainer.innerHTML = `<img src="${variantlogo}" alt="Promo Badge" style="max-width: 100%; height: auto;" />`;
      //         logoContainer.style.display = 'block';
      //        console.log("logoContainer--if---",logoContainer.innerHTML);
      //     } else {
      //         logoContainer.innerHTML = '';
      //         logoContainer.style.display = 'none';
      //        console.log("logoContainer--else---",logoContainer.innerHTML);
            
      //     }   
      //   }
        
      //     console.log("selPromoBadge--",variantlogo);
      // }

      var container = e.closest('.product-template-inner-wrap-container');
      
      if (container) {
          var logoContainer = container.querySelector('.product-gallery-container .product-gallery .wrapper-promo-badge');
          var variantlogo = e.dataset.logo;
          var variantamount = e.dataset.amount;
          var variantheding = e.dataset.heding;
          var variantsubheding = e.dataset.sub_heding;
          console.log("variantheding--",variantheding);
          console.log("variantsubheding--",variantsubheding);
        
          if (logoContainer) {
            logoContainer.innerHTML = '';
        
            if (variantlogo) {
              logoContainer.innerHTML = `<img src="${variantlogo}" alt="Promo Badge" style="max-width: 100%; height: auto;" />`;
              logoContainer.style.display = 'block';
        
            } else if (variantamount || variantheding || variantsubheding) {
              logoContainer.innerHTML = `
                <div class="badge-container">
                  <div class="badge-outer"></div>
                  
                  <div class="badge-inner">
                    ${variantamount ? `<div class="discount-text">${variantamount}</div><div class="discount-text">OFF</div>` : ''}
                  </div>
                  
                  <svg class="svg-text" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path id="topArc" d="M 30,100 A 70,70 0 0,1 170,100" fill="none"/>
                    <text font-size="18" fill="#0e2c44" font-weight="bold">
                      <textPath href="#topArc" startOffset="50%" text-anchor="middle">
                        ${variantheding || ''}
                      </textPath>
                    </text>
        
                    <path id="bottomArc" d="M 170,100 A 70,70 0 0,1 30,100" fill="none"/>
                    <text font-size="12" fill="#0e2c44" font-weight="bold">
                      <textPath href="#bottomArc" startOffset="50%" text-anchor="middle">
                        ${variantsubheding || ''}
                      </textPath>
                    </text>
                  </svg>
                </div>
              `;
              logoContainer.style.display = 'block';
        
            } else {
              // No data, hide badge
              logoContainer.style.display = 'none';
            }
          }
        }

     
      
    });
  });

  document.querySelectorAll('.product-gallery__thumbnail').forEach( (thumbList) => {
    thumbList.addEventListener('click', function(){
      setTimeout(function(){
      var thumb_src = thumbList.querySelector('a').getAttribute('href');
      if(document.querySelector('.product-gallery__media[aria-hidden="true"]') != null){
        // console.log("true---");
        var media_src = document.querySelector('.product-gallery__media[aria-hidden="true"]').querySelector('a');
        media_src.setAttribute('href',thumb_src);      
        media_src.querySelector('.mz-lens img').setAttribute('src',thumb_src);
        media_src.querySelector('figure > img').setAttribute('src',thumb_src);
      }
      if( document.querySelectorAll('.mz-zoom-window').length > 0){
        document.querySelector('.mz-zoom-window img').src = thumb_src;
      }      
      },900);
      
    });
  });

});
const pdpimage_selector = document.querySelector('#pgmz');
if(pdpimage_selector) {
  pdpimage_selector.addEventListener('click', function () {
    setTimeout(function(){
      var mainImg = 'https:'+$('#pgmz').attr('href');
      $('.magic-thumb').removeClass('magic-thumb-selected')
      $('.magic-thumb img[src="'+mainImg+'"]').parent().addClass('magic-thumb-selected')
      $('.mz-expand .mz-figure>img').attr('src',mainImg);    
      MZimage();
    },1000);
  });
}
// let myEvent = new Event('click');
// pdpimage_selector.dispatchEvent(myEvent);

function MZimage() {
  document.querySelectorAll('.magic-thumb').forEach( el => {
    el.addEventListener('click', function (){
      var mzthumb_src = el.querySelector('img').getAttribute('src'); 
      if(document.querySelector('.product-gallery__media') != null){
        var main_src = document.querySelector('.product-gallery__media').querySelector('a');
        main_src.setAttribute('href',mzthumb_src);  
        if(main_src.querySelector('.mz-lens img') != null){
          main_src.querySelector('.mz-lens img').setAttribute('src',mzthumb_src);
        }
        if(main_src.querySelector('figure > img') != null){
          main_src.querySelector('figure > img').setAttribute('src',mzthumb_src);
        }
      }
    })
  });
}

$(document).ready(function(){
  $('.mz-button-close').click(function(){
    setTimeout(function(){
      changeDiv();
    },1000);
  }); 
  
  document.addEventListener("keydown", ({key}) => {
    if (key === "Escape") {
      setTimeout(function(){
        changeDiv();
      },1000);     
    }
  });

  $('body').click(function(){
    setTimeout(function(){
      changeDiv();
    },1000);     
  });
});

function changeDiv() {
  var mainmediaImg = 'https:'+$('#pgmz').attr('href');
  $('.mz-lens img').attr('src',mainmediaImg);  
}

var x = 1024;
window.addEventListener("resize", reportWindowSize);
window.addEventListener("load", reportWindowSize);
function reportWindowSize() {
  if(window.innerWidth > x){
    if(document.querySelector('.product__dec-img .relative')){
      var getHeight = document.querySelector('.product__dec-img .relative').clientHeight;
    }
    if(document.querySelector('.product__dec')){
      document.querySelector('.product__dec').style.maxHeight = `${getHeight}px`;
    }
  }else{
    if(document.querySelector('.product__dec')){
      document.querySelector('.product__dec').style.maxHeight = "100%";
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

document.addEventListener("DOMContentLoaded", function(event) {
  var productGrids = document.querySelectorAll('.grid__item, .products-carousel-item-container');

  productGrids.forEach(function(grid) {
    var swatchSelector = grid.querySelectorAll('.product-item__variants .product-variant');
    swatchSelector.forEach(function(swatch){
      swatch.addEventListener("click", function(e) {
        swatchSelector.forEach(function(swatch){
            swatch.classList.remove("selected");
        });
        e.currentTarget.classList.add("selected");
        var variantID = e.currentTarget.getAttribute('data-id');
        var variantPrice = e.currentTarget.getAttribute('data-price');
        var variantlogo = e.currentTarget.getAttribute('data-logo');
        var variantamount = e.currentTarget.getAttribute('data-amount');
        var variantsubheding = e.currentTarget.getAttribute('data-sub_heding');
        var variantheding = e.currentTarget.getAttribute('data-heding');
        var container_grid__item = e.currentTarget.closest('.grid__item, .products-carousel-item-container');
        var logoImage = container_grid__item.querySelector('.wrapper-promo-badge img');
        var logoContainer = container_grid__item.closest('.grid__item, .products-carousel-item-container').querySelector('.wrapper-promo-badge');
        
          
        var addCartBtn = e.currentTarget.closest('.product-item-bottom__wrapper, .product-carousel-bottom-info-container').querySelector('.grid-atc-btn, .grid-soldout-btn');
        
        addCartBtn.dataset.id = variantID;
  
        e.currentTarget.closest('.product-item-bottom__wrapper, .product-carousel-bottom-info-container').querySelector('.product-price-container span').innerHTML = variantPrice;

        console.log("variantamount---",variantamount);
        console.log("variantsubheding--",variantsubheding);
        console.log("variantheding---",variantheding);
        
        if (logoContainer) {
          if (variantamount) {
            // logoContainer.innerHTML = `<img src="${variantlogo}" alt="Promo Badge" style="max-width: 100%; height: auto;" />`;
            logoContainer.innerHTML =
          `<div class="badge-container">
            <div class="badge-outer"></div>
            <div class="badge-inner">
              ${variantamount ? `<div class="discount-text">${variantamount}</div><div class="discount-text">OFF</div>` : ''}
            </div>
            <svg class="svg-text" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path id="topArc" d="M 30,100 A 70,70 0 0,1 170,100" fill="none"/>
              <text font-size="18" fill="#0e2c44" font-weight="bold">
                <textPath href="#topArc" startOffset="50%" text-anchor="middle">
                  ${variantheding || ''}
                </textPath>
              </text>
              <path id="bottomArc" d="M 170,100 A 70,70 0 0,1 30,100" fill="none"/>
              <text font-size="12" fill="#0e2c44" font-weight="bold">
                <textPath href="#bottomArc" startOffset="50%" text-anchor="middle">
                  ${variantsubheding || ''}
                </textPath>
              </text>
            </svg>
          </div>`;
            logoContainer.style.display = 'block';
          } else {
            logoContainer.innerHTML = '';
            logoContainer.style.display = 'none';
          }
        }
        
        
        if(e.currentTarget.classList.contains('disabled')){
          addCartBtn.classList.remove('grid-atc-btn', 'bg-midnight', 'hover:bg-slate');
          addCartBtn.classList.add('grid-soldout-btn');
          addCartBtn.setAttribute('disabled', 'disabled');
          addCartBtn.innerHTML = 'Sold Out';
        } else {
          addCartBtn.classList.remove('grid-soldout-btn');
          addCartBtn.classList.add('grid-atc-btn', 'bg-midnight', 'hover:bg-slate');
          addCartBtn.removeAttribute('disabled');
          addCartBtn.innerHTML = 'Add to Cart';
        }
      })
    })
  })
  
  document.querySelectorAll(".grid-atc-btn").forEach(function (e) {
    e.addEventListener("click", function () {
      var dataId = e.dataset.id;
      if(e.hasAttribute('data-prop')){
        var dataProp = {
          "_prop65Product": "true"
        }
      }
      fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: dataId,
            quantity: 1,
            properties: dataProp
          })
      })
      .then((data) => {
          if(data.status === 200){                  
            console.log("Add Done");
            //window.location.href = '/cart'
          }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
    });
  });
});

//iframe renaming

document.addEventListener('DOMContentLoaded', function() {
    // Function to set unique titles for each iframe
    function setUniqueIframeTitles() {
        // Select all iframes on the page
        var iframes = document.getElementsByTagName('iframe');

        // Loop through each iframe and set a unique title
        for (var i = 0; i < iframes.length; i++) {
            var iframe = iframes[i];
            iframe.title = 'Vital Nutrients ' + (i + 1); // Unique title based on index
        }
    }

    // Set unique titles initially
    setUniqueIframeTitles();

    // MutationObserver to handle dynamically added iframes
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.tagName === 'IFRAME') {
                        var iframes = document.getElementsByTagName('iframe');
                        var index = Array.prototype.indexOf.call(iframes, node);
                        node.title = 'Iframe Title ' + (index + 1); // Unique title based on index
                    }
                });
            }
        });
    });

    // Configure and start the observer
    observer.observe(document.body, { childList: true, subtree: true });
});







  // document.addEventListener('DOMContentLoaded', function () {
  //   const variants = document.querySelectorAll('.product-variant');
  //   const promoContainer = document.getElementById('promo-badge-container');
  //   let activeVariantId = null;

  //   variants.forEach(variant => {
  //     variant.addEventListener('click', function () {
  //       const promoImage = this.dataset.promoImage;
  //       const variantId = this.dataset.id;

  //       // Always update promo image, even if same variant
  //       updatePromoBadge(promoImage);

  //       // Update selected styling
  //       variants.forEach(v => v.classList.remove('selected'));
  //       this.classList.add('selected');

  //       // Save the current variant ID
  //       activeVariantId = variantId;
  //     });
  //   });

  //   function updatePromoBadge(promoImage) {
  //     promoContainer.innerHTML = ''; // Clear old image

  //     if (promoImage && promoImage.trim() !== '') {
  //       const img = document.createElement('img');
  //       img.src = promoImage;
  //       img.alt = 'Promotional Badge';
  //       img.className = 'promo-badge-image';
  //       promoContainer.appendChild(img);
  //     }
  //   }
  // });









